import { api } from '@/lib/api/http'
import type { SystemNoticeFeed } from '../types'

/**
 * Neither service publishes a notices route yet — the auth micro-service ends at
 * `auth`, `file`, `installation`, `profile`, `role` and `setting`. The flag is
 * the whole seam: while it is false the query never fires and the panel says so
 * plainly, rather than inventing messages a merchant might act on.
 *
 * When the routes land, point the two paths at them and flip this to true.
 * Nothing above this file changes.
 */
export const isSystemNoticesAvailable = false

const NOTICES_PATH = '/v1/notices'

export function fetchSystemNotices(): Promise<SystemNoticeFeed> {
  return api.get<SystemNoticeFeed>(NOTICES_PATH)
}

export function markAllNoticesRead(): Promise<void> {
  return api.post<void>(`${NOTICES_PATH}/read`)
}
